export default __webpack_public_path__ + "static/info_3-99811f93e42e87eaf98bbd4dd39ea7ce.png";